import React, { useState } from "react";
import { Button } from "@lightspeed/flame/Button";
import { Input } from "@lightspeed/flame/Input";
import QuickBooksClassDepartmentModal from "./QuickBooksClassDepartmentModal";

const QuickBooksClassDepartmentField = ({
  value,
  onChange,
  classDepartments,
  onEnter,
  children,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div style={{ position: "relative", display: "flex", alignItems: "center", gap: 4 }}>
        <Input
          className="input-wrapper-row-inputbox"
          type="text"
          size="small"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter" && onEnter) onEnter();
          }}
        />
        {children}
        <Button size="small" onClick={() => setOpen(true)}>
          Select
        </Button>
      </div>
      <QuickBooksClassDepartmentModal
        open={open}
        value={value}
        classDepartments={classDepartments}
        onClose={() => setOpen(false)}
        onApply={onChange}
      />
    </>
  );
};

export default QuickBooksClassDepartmentField;
